import moment from 'moment';
import { formValueSelector } from 'redux-form';

function peerValueToBoundString(raw, withTime) {
    if (raw == null || raw === '')
        return undefined;
    try {
        const m = moment.isMoment(raw) && typeof raw.clone === 'function'
            ? raw.clone()
            : moment(raw);
        if (!m || !m.isValid || !m.isValid())
            return undefined;
        return withTime ? m.format('YYYY-MM-DDTHH:mm') : m.format('YYYY-MM-DD');
    } catch (_e) {
        return undefined;
    }
}

function parseFlexibleBound(str, withTime) {
    if (str == null || str === '')
        return null;
    if (withTime) {
        const s = String(str);
        if (s.length === 10)
            return moment(s, 'YYYY-MM-DD', true);
        return moment(s);
    }
    return moment(str, 'YYYY-MM-DD', true);
}

/** Native `min` = latest lower bound (strictest floor). */
function stricterNativeMin(boundA, boundB, withTime) {
    if (boundB == null || boundB === '')
        return boundA;
    if (boundA == null || boundA === '')
        return boundB;
    const ma = parseFlexibleBound(boundA, withTime);
    const mb = parseFlexibleBound(boundB, withTime);
    if (!ma?.isValid() && !mb?.isValid())
        return boundA;
    if (!ma?.isValid())
        return boundB;
    if (!mb?.isValid())
        return boundA;
    const m = ma.isAfter(mb) ? ma : mb;
    return withTime ? m.format('YYYY-MM-DDTHH:mm') : m.format('YYYY-MM-DD');
}

/** Native `max` = earliest upper bound (strictest ceiling). */
function stricterNativeMax(boundA, boundB, withTime) {
    if (boundB == null || boundB === '')
        return boundA;
    if (boundA == null || boundA === '')
        return boundB;
    const ma = parseFlexibleBound(boundA, withTime);
    const mb = parseFlexibleBound(boundB, withTime);
    if (!ma?.isValid() && !mb?.isValid())
        return boundA;
    if (!ma?.isValid())
        return boundB;
    if (!mb?.isValid())
        return boundA;
    const m = ma.isBefore(mb) ? ma : mb;
    return withTime ? m.format('YYYY-MM-DDTHH:mm') : m.format('YYYY-MM-DD');
}

export function mapPeerBounds(state, ownProps) {
    const form = ownProps.meta?.form;
    const withTime = ownProps.timeFormat !== false;
    const {
        minBoundField,
        maxBoundField,
        min: minProp,
        max: maxProp,
    } = ownProps;

    const out = {};

    if (form && minBoundField) {
        const raw = formValueSelector(form)(state, minBoundField);
        const fromPeer = peerValueToBoundString(raw, withTime);
        out.min = stricterNativeMin(fromPeer, minProp, withTime);
    }

    if (form && maxBoundField) {
        const raw = formValueSelector(form)(state, maxBoundField);
        const fromPeer = peerValueToBoundString(raw, withTime);
        out.max = stricterNativeMax(fromPeer, maxProp, withTime);
    }

    return out;
}
